import React from "react";
import { Badge } from "reactstrap";
import { capitalizeFirstLetter } from "../../utils/utils";

const UserStatusBadge = ({ status, color, fontSize, ...otherProps }) => {
  return (
    <Badge
      color={!color ? "success" : color}
      className={`fw-normal `}
      style={{
        borderRadius: "8px",
        fontSize: fontSize ? `${fontSize}px` : "11px",
      }}
      {...otherProps}
    >
      {capitalizeFirstLetter(status)}
    </Badge>
  );
};

export default UserStatusBadge;
